import { Layout, Menu } from 'antd';
import {
  BarChartOutlined,
  AuditOutlined,
  ToolOutlined,
  SettingOutlined,
  EnvironmentOutlined,
  GlobalOutlined
} from '@ant-design/icons';
import SubMenu from 'antd/lib/menu/SubMenu';
import { NavLink } from 'react-router-dom';




export default function Sidebar({ collapsed }) {
  const { Sider } = Layout;

  return (
    <Sider theme='light' trigger={null} collapsible collapsed={collapsed} width="250">
      <div className="logo">
          {collapsed ?"BG":"Best Group"}
          </div>
      <Menu theme="light" mode="inline" defaultSelectedKeys={[window.location.pathname]}>
        <Menu.Item key="/" icon={<BarChartOutlined />} style={{borderBottom:'1px solid rgba(238, 238, 238, 0.7)'}}>
          <NavLink activeStyle={{color: "#ffffff"}} to='/home'>Dashboard</NavLink>
        </Menu.Item> 
      
        <SubMenu key="/hr" icon={<AuditOutlined />} title="HR" style={{borderBottom:'1px solid rgba(238, 238, 238, 0.7)'}}>
        <Menu.Item key="/salary" icon={<AuditOutlined />}>
          <NavLink activeStyle={{color: "#ffffff"}} to='/salary'>Salary</NavLink>
        </Menu.Item>
        <Menu.Item key="/employeelist" icon={<AuditOutlined />}>
          <NavLink activeStyle={{color: "#ffffff"}} to='/employeelist'>Employees</NavLink>
        </Menu.Item>
        </SubMenu>
        <SubMenu key="/office" icon={<ToolOutlined />} title="Office" style={{borderBottom:'1px solid rgba(238, 238, 238, 0.7)'}}>

        <Menu.Item key="/dailyexpese" icon={<ToolOutlined />}>
          <NavLink activeStyle={{color: "#ffffff"}} to='/dailyexpense'>Daily Expense</NavLink>
          
        </Menu.Item>
        
        <Menu.Item key="/fixedexpense" icon={<ToolOutlined />}>
          <NavLink activeStyle={{color: "#ffffff"}} to='/fixedexpense'>Fixed Expense</NavLink>
          
        </Menu.Item>
     
        </SubMenu>
        <SubMenu key="/invoice" icon={<ToolOutlined />} title="Invoices" style={{borderBottom:'1px solid rgba(238, 238, 238, 0.7)'}}>

          <Menu.Item key="/invoicelist" icon={<ToolOutlined />}>
            <NavLink activeStyle={{color: "#ffffff"}} to='/invoicelist'>Invoices</NavLink>
            
          </Menu.Item>
          </SubMenu>
        <SubMenu key="/overseas" icon={<SettingOutlined />} title="Overseas" style={{borderBottom:'1px solid rgba(238, 238, 238, 0.7)'}}>
        <Menu.Item key="/countries" icon={<GlobalOutlined />}>
          <NavLink activeStyle={{color: "#ffffff"}} to='/demandletter'>Demand letter</NavLink>
        </Menu.Item>
        <Menu.Item key="/employeecontract" icon={<EnvironmentOutlined />}>
          <NavLink activeStyle={{color: "#ffffff"}} to='/employeecontract'>New Employee contract</NavLink>
        </Menu.Item>
        <Menu.Item key="/commitmentletter" icon={<EnvironmentOutlined />}>
          <NavLink activeStyle={{color: "#ffffff"}} to='/commitmentletter'>Commitment letter</NavLink>
        </Menu.Item>
        <Menu.Item key="/supportQuotation" icon={<EnvironmentOutlined />}>
          <NavLink activeStyle={{color: "#ffffff"}} to='/supportQuotation'>Quotation</NavLink>
        </Menu.Item>
        </SubMenu>
        <SubMenu key="/business" icon={<ToolOutlined />} title="Business" style={{borderBottom:'1px solid rgba(238, 238, 238, 0.7)'}}>

        <Menu.Item key="/businesslist" icon={<ToolOutlined />}>
          <NavLink activeStyle={{color: "#ffffff"}} to='/businesslist'>Businesses</NavLink>
          
        </Menu.Item>

        <Menu.Item key="/clientlist" icon={<ToolOutlined />}>
          <NavLink activeStyle={{color: "#ffffff"}} to='/clientlist'>Clients</NavLink>
          
        </Menu.Item>
        <Menu.Item key="/projectlist" icon={<ToolOutlined />}>
          <NavLink activeStyle={{color: "#ffffff"}} to='/projectlist'>Projects</NavLink>
          
        </Menu.Item>

        </SubMenu>
        <SubMenu key="/setting" icon={<SettingOutlined />} title="Settings" style={{borderBottom:'1px solid rgba(238, 238, 238, 0.7)'}}>

<Menu.Item key="/expenseCategorylist" icon={<ToolOutlined />}>
  <NavLink activeStyle={{color: "#ffffff"}} to='/expenseCategorylist'>Expense Category</NavLink>
  
</Menu.Item>
</SubMenu>
      </Menu>
    </Sider>
  )
}